// StaffTitle — danh hiệu đang đeo, đặt ngay sau tên nhân sự (CEO 9a+b, 17/10/2026).
// Không đeo / chưa tải / tải lỗi ⇒ không vẽ gì, chỗ tên y như cũ.
import { useContext } from "react";
import { QueryClientContext } from "@tanstack/react-query";
import { cn } from "@/lib/utils";
import { normalizeName, useStaffAvatarMap } from "@/lib/staff-avatar";
import { useEquippedFor } from "./api";

// `name` cho nơi chỉ có tên: tra mã theo tên DUY NHẤT, cùng luật với StaffAvatar.
type Props = {
  staffId?: string | null | undefined;
  name?: string | null | undefined;
  className?: string | undefined;
};

// Thành phần LÁ ở ~50 màn: cây không có QueryClientProvider (bài kiểm dựng
// riêng một màn) thì không tra gì, không vẽ gì — như khung ở StaffAvatar.
export function StaffTitle(props: Props) {
  return useContext(QueryClientContext) ? <DanhHieu {...props} /> : null;
}

function DanhHieu({ staffId, name, className }: Props) {
  const { byName } = useStaffAvatarMap();
  const id = staffId || (name ? byName[normalizeName(name)]?.id : undefined);
  const label = useEquippedFor(id)?.title?.label;
  if (!label) return null;
  return (
    <span
      className={cn(
        "staff-title inline-block max-w-full truncate align-middle text-[11px] font-medium leading-tight text-[#9a6b1f]",
        className,
      )}
      title={`Danh hiệu: ${label}`}
    >
      {label}
    </span>
  );
}
